module.exports = __webpack_public_path__ + "img/teacher1.ee9fda9b.png";